import {
  localSave,
  localRead
} from './lang';
import i18n from '@/plugins/i18n';
import AuthApi from "@/services/auth.service";
import Cookies from 'js-cookie';

export default {
  state: {
    local: localRead('local'),
  },
  mutations: {
    setLocal(state, lang) {
      localSave('local', lang);
      state.local = lang;
    },
    vueTableFormatJson(restData) {
      let jsonData = restData.data;
      //console.log(jsonData, 'vueTableFormatJson');
      let data = [];
      for (let [k, v] of Object.entries(jsonData)) {
        switch (k) {
          case 'links':
            let link = []
            for (let [kLink, vLink] of Object.entries(v)) {
              link[kLink + '_page_url'] = vLink
            }
            data = { ...data, ...link };
            break;
          case 'meta':
            data = { ...data, ...v };
            break;
          case 'data':
            data = { ...data, ... { data: v } };
            break;
          default:
            data[k] = { ...data[k], ...v };
        }
      }
      if (data.from && data.per_page && !data.to) {
        if (data.per_page > data.total) {
          data.to = data.total;
        } else {
          data.to = data.from + data.per_page - 1;
        }
      }
      return data;
    },
  },
  getImage(fileName) {
    var image = require('@/assets/images/no-image.png');
    try {
      image = '<img src="' + this.getImageSrc(fileName) + '" width="24">';
    } catch (error) {
      console.log(error, 'error');
    }
    return image;
  },
  badgeClass() {
    return [
      'badge-secondary',
      'badge-primary',
      'badge-success',
      'badge-info',
      'badge-warning',
      'badge-danger',
    ];
  },
  getImageSrc(fileName, extension = '.png') {
    let images = require('@/assets/images/no-image.png');
    try {
        images = require('@/assets/images/' + fileName + extension);
        // images = require('@/assets/images/COD.png');
    } catch (err) {}
    return images
  },
  getImageGobalAssets(fileName) {
    let images = require('@/assets/images/no-image.png');
    try {
      images = require('@/assets/global_assets/images/' + fileName + '.png');
    } catch (err) {
      // console.log(fileName, 'getImageGobalAssets error');
    }
    return images

  },
  getLogoGlobalSvgAssets(fileName) {
    let images = require('@/assets/images/no-image-profile.png');
    try {
      images = require('@/assets/global_assets/images/' + fileName + '.svg' || '.png');
    } catch (err) {
      // console.log(fileName, 'getImageGobalAssets error');
    }
    return images

  },
  getImageGlobalSvgAssets(fileName) {
    let images = require('@/assets/global_assets/images/default-user.svg');
    try {
      images = require('@/assets/global_assets/images/' + fileName + '.svg' || '.png');
    } catch (err) {
      // console.log(fileName, 'getImageGobalAssets error');
    }
    return images

  },
  getImageSvgAssets(fileName) {
    let images = require('@/assets/global_assets/images/default-user.svg');
    try {
      images = require('@/assets/images/' + fileName + '.svg' || '.png');
    } catch (err) {
      // console.log(fileName, 'getImageGobalAssets error');
    }
    return images

  },
  isset(accessor) {
    try {
      // Note we're se
      return typeof accessor() !== 'undefined'
    } catch (e) {
      return false
    }
  },

  monthNames() {
    return [i18n.t("Jan"), i18n.t("Feb"), i18n.t("Mar"), i18n.t("Apr"), i18n.t("May"), i18n.t("Jun"), i18n.t("Jul"), i18n.t("Aug"), i18n.t("Sep"), i18n.t("Oct"), i18n.t("Nov"), i18n.t("Dec"), i18n.t("January"), i18n.t("February"), i18n.t("March"), i18n.t("April"), i18n.t("May"), i18n.t("June"), i18n.t("July"), i18n.t("August"), i18n.t("September"), i18n.t("October"), i18n.t("November"), i18n.t("December")].slice(0, 12);
  },

  daysOfWeek() {
    return [i18n.t("Sun"), i18n.t("Mon"), i18n.t("Tue"), i18n.t("Wed"), i18n.t("Thu"), i18n.t("Fri"), i18n.t("Sat"), i18n.t("Sunday"), i18n.t("Monday"), i18n.t("Tuesday"), i18n.t("Wednesday"), i18n.t("Thursday"), i18n.t("Friday"), i18n.t("Saturday")].slice(0, 7).map((function (t) {
      return t.substring(0, 2)
    }))
  },

  ranges() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let todayEnd = new Date()
    todayEnd.setHours(11, 59, 59, 999);

    let yesterdayStart = new Date()
    yesterdayStart.setDate(today.getDate() - 1)
    yesterdayStart.setHours(0, 0, 0, 0);

    let yesterdayEnd = new Date()
    yesterdayEnd.setDate(today.getDate() - 1)
    yesterdayEnd.setHours(11, 59, 59, 999);

    let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);

    const defaultRanges = {
      'Today': [today, todayEnd],
      'Yesterday': [yesterdayStart, yesterdayEnd],
      'This month': [thisMonthStart, thisMonthEnd],
      'This year': [
        new Date(today.getFullYear(), 0, 1),
        new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
      ],
      'Last month': [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
      ],
    }

    let _ranges = [];
    for (const [key, value] of Object.entries(defaultRanges)) {
      _ranges[i18n.t(key)] = value;
    }
    return Object.assign({}, _ranges);

  },
  getCarrierCode(integrationTypeId) {
    var carrierCode = '';
    switch (integrationTypeId.toString()) {
      case '4':
        carrierCode = 'KERRY_EXPRESS';
        break;
      case '5':
        carrierCode = 'THAIPOST';
        break;
      case '6':
        carrierCode = 'FLASH_EXPRESS';
        break;
      case '8':
        carrierCode = 'J&T_EXPRESS';
        break;
      default:
        carrierCode = '-';
        break;
    }
    return carrierCode;
  },
  async gotoGoSaas(self, logOut) {
    await AuthApi.logOut();
    Cookies.remove("centralToken");
    Cookies.remove("callbackUrl");
    Cookies.remove("merchantName");
    Cookies.remove("latestProducts");
    if (!logOut) self.$toastr.e(
      i18n.t("Token Expired"),
      "<span class='icon-blocked'></span>" + i18n.t("Error")
    );
    setTimeout(() => {
      window.close();
      if (Cookies.get("callbackUrl"))
        location.href = Cookies.get("callbackUrl") + "/app/integrations?integration_group_id=5";
      else if (process.env.GOSAAS_BASE_URL) location.href = process.env.GOSAAS_BASE_URL;
    }, 5000);
  },
  async logoutBackoffice(self, logOut) {
    await AuthApi.logOut();
    Cookies.remove("centralToken");
    Cookies.remove("callbackUrl");
    Cookies.remove("merchantName");
    Cookies.remove("latestProducts");
    Cookies.remove("Token");
    self.$store.dispatch("setClearAllData")
    self.$store.dispatch("backofficeLogout")
    Cookies.remove("backofficeToken");

    if (!logOut) self.$toastr.e(
      i18n.t("Token Expired"),
      "<span class='icon-blocked'></span>" + i18n.t("Error")
    );

    self.$router.push("/backoffice/login").catch(() => { });
  },
};



// WEBPACK FOOTER //
// ./src/store/index.js